//GeneratorFlag:[NoChange]
import Person from './person';
import PersonAccess from './person-access';
import PersonLegal from './person-legal';
import PersonReal from './person-real';
import PersonVehicle from './person-vehicle';

export default {Person, PersonAccess, PersonLegal, PersonReal, PersonVehicle}
export{Person, PersonAccess, PersonLegal, PersonReal, PersonVehicle}